export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40864a8838d97758872e1bccbfe1e2ab2712494c5d&name=revalidateCommunity!'